// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sticky-sideNav[data-v-41658ff8]{max-width:35%}.alert-bar[data-v-41658ff8]{margin-top:-1px;margin-left:-1px}h1[data-v-41658ff8],h2[data-v-41658ff8]{color:#0e76bd}", ""]);
// Exports
module.exports = exports;
